import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
//import 'swiper/css/effect-fade';

Swiper.use([Autoplay, Pagination, Navigation]);

// import $ from 'jquery';
// window.$ = window.jQuery = $;

import { Fancybox } from '@fancyapps/ui';

Fancybox.bind('[data-fancybox]', {
  animated: true,
  showClass: 'f-fadeIn',
  hideClass: 'f-fadeOut',
});



const reviews = new Swiper('.reviews-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 24,
  centeredSlides: false,
  pagination: {
    el: '.reviews__pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: '.reviews-slider__next',
    prevEl: '.reviews-slider__prev',
  },

  breakpoints: {
    768: {
      spaceBetween: 24,
      slidesPerView: 2,
    },
  },
});







jQuery(function ($) {



  const heroslider = new Swiper('.heroslider-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    centeredSlides: false,
    pagination: {
      el: '.heroslider__pagination',
      type: 'bullets',
      clickable: 'true',
    },
  });


  jQuery(function ($) {
    const container = document.querySelector('.movingstripe__outerwrap_mobile .movingstripe');
    if (container) {
      const inner = document.querySelector('.movingstripe__outerwrap_mobile .movingstripe__inner');
      const speed = 50; // пикселей в секунду
      let pos = 0;

      // Дублируем контент один раз
      inner.innerHTML += inner.innerHTML;

      const singleWidth = inner.scrollWidth / 2;

      function animate() {
        pos -= speed / 60; // движение на кадр (60fps)
        if (Math.abs(pos) >= singleWidth) {
          pos += singleWidth; // сбрасываем, но плавно
        }
        inner.style.transform = `translateX(${pos}px)`;
        requestAnimationFrame(animate);
      }

      requestAnimationFrame(animate);
    }
  });


  jQuery(function ($) {
    const container = document.querySelector('.movingstripe__outerwrap_desktop .movingstripe');
    if (container) {
      const inner = document.querySelector(
        '.movingstripe__outerwrap_desktop .movingstripe__inner'
      );
      const speed = 50; // пикселей в секунду
      let pos = 0;

      // Дублируем контент один раз
      inner.innerHTML += inner.innerHTML += inner.innerHTML;

      const singleWidth = inner.scrollWidth / 2;

      function animate() {
        pos -= speed / 60; // движение на кадр (60fps)
        if (Math.abs(pos) >= singleWidth) {
          pos += singleWidth; // сбрасываем, но плавно
        }
        inner.style.transform = `translateX(${pos}px)`;
        requestAnimationFrame(animate);
      }

      requestAnimationFrame(animate);
    }
  });


 jQuery(function ($) {
   const container = document.querySelector('.movingstripe__outerwrap_footer .movingstripe');
   if (container) {
     const inner = document.querySelector('.movingstripe__outerwrap_footer .movingstripe__inner');
     const speed = 50; // пикселей в секунду
     let pos = 0;

     // Дублируем контент один раз
     inner.innerHTML += inner.innerHTML += inner.innerHTML;

     const singleWidth = inner.scrollWidth / 2;

     function animate() {
       pos -= speed / 60; // движение на кадр (60fps)
       if (Math.abs(pos) >= singleWidth) {
         pos += singleWidth; // сбрасываем, но плавно
       }
       inner.style.transform = `translateX(${pos}px)`;
       requestAnimationFrame(animate);
     }

     requestAnimationFrame(animate);
   }
 });


  jQuery(function ($) {

    const header = $('.header');
    let stickyOffset = header.height();
    document.documentElement.style.setProperty('--header-h', stickyOffset + 'px');


    function updateHeaderSticky() {
      if ($(window).scrollTop() > 0) {
        header.addClass('header_sticky');
        $('body').addClass('has-sticky-space');
      } else {
        header.removeClass('header_sticky');
        $('body').removeClass('has-sticky-space');
      }
    }

    // Проверка при загрузке
    updateHeaderSticky();

    // Проверка при прокрутке
    $(window).on('scroll', updateHeaderSticky);
  });


  $('.menubtn').on('click', function () {
    $('.header').toggleClass('header_mobileopen');
    $(this).toggleClass('menubtn_opened');
    $('body').toggleClass('scroll-lock');
  });


  $('.header, .heroslider').on('click', 'a[href^="#"]', function (event) {
    //$('.header nav.opened').slideUp();
    $('.header nav').removeClass('opened');
    $('.header__menu-icon-wrap').removeClass('header__menu-icon-wrap_opened');
    $('body').removeClass('lock-scroll');
    event.preventDefault();

    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top - 63,
      },
      500
    );
    window.location.hash = this.hash;
  });



jQuery(function ($) {

    const $filters = $('.cat-filters__item');
    const $cards   = $('.snacks-cat__card');

    $filters.on('click', function () {
        const activeCat = $(this).data('cat');




        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            $cards.show();
            return;
        } else {

          $filters.removeClass('is-active');
          $(this).addClass('is-active');
          $(this).fadeIn(200);
        }

        $cards.each(function () {
            const cardCats = $(this).data('cat').toString().split(' ');

            if (cardCats.includes(activeCat)) {
                $(this).show();
                $(this).fadeIn(200);
            } else {
                $(this).hide();
                $(this).fadeOut(200);
            }
        });
    });

});







});
